type FloatingInputProps = {
  id?: string;
  name: string;
  label: string;
  type?: 'text' | 'email' | 'password';
  autoComplete?: string;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  disabled?: boolean;
  value: string;
  onChange: (value: string) => void;
};

export function FloatingInput({
  id,
  name,
  label,
  type = 'text',
  autoComplete,
  required,
  minLength,
  maxLength,
  disabled,
  value,
  onChange,
}: FloatingInputProps) {
  return (
    <div className="relative">
      <input
        id={id ?? name}
        name={name}
        type={type}
        maxLength={maxLength}
        minLength={minLength}
        autoComplete={autoComplete}
        placeholder=" "
        required={required}
        value={value}
        disabled={disabled}
        className="peer block w-full appearance-none rounded-md border border-gray-300 px-3 pt-3 pb-2 text-sm shadow-xs focus:border-indigo-500 focus:outline-hidden focus:ring-indigo-500 disabled:bg-gray-100 disabled:text-gray-500"
        onChange={(event) => onChange(event.target.value)}
      />
      <label
        htmlFor={id ?? name}
        className="absolute inset-s-3 top-2 z-10 origin-left -translate-y-4 transform bg-white px-2 text-gray-400 text-sm duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-placeholder-shown:bg-transparent peer-placeholder-shown:px-0 peer-placeholder-shown:text-gray-400 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:bg-white peer-focus:px-2 peer-focus:text-indigo-600"
      >
        {label}
      </label>
      {maxLength && (
        <div className="absolute top-2.25 right-3 z-10 text-gray-500 text-sm">
          {value.length}/{maxLength}
        </div>
      )}
    </div>
  );
}
